"use client";
import { cn } from "@/lib/utils";
import React from "react";
import { addEventAttributes } from "../ui-script/utils";

function PreviousRecommendations({
  selectedTab,
  setSelectedTab,
  setSelectedSubTab,
  type = "collection",
}) {
  return (
    <div className="hp-border-r-[2px] hp-border-gray-200 hp-pr-2">
      <div
        className={cn(
          "hp-inline-flex hp-cursor-pointer hp-items-center hp-gap-x-1.5 hp-rounded-full hp-bg-gray-100 hp-px-3 hp-py-1 hp-text-xs hp-font-medium hp-text-gray-600",
          {
            "hp-border hp-border-white hp-text-white hp-bg-black": selectedTab,
          },
        )}
        style={{
          fontSize: "13px",
          fontWeight: "600",
          backgroundColor: selectedTab ? "black" : "rgb(243, 244, 246)",
          color: selectedTab ? "white" : "",
          borderColor: selectedTab ? "white" : "rgb(243, 244, 246)",
        }}
        onClick={() => {
          setSelectedTab("previous-recommendations");
          if (type === "collection") {
            setSelectedSubTab("");
          }
        }}
        {...addEventAttributes({
          eventName: "recently-viewed",
          eventData: {},
        })}
      >
        Recently Viewed
      </div>
    </div>
  );
}

export default PreviousRecommendations;
